<template>
<div class="card job-card" :class="additionalClasses">
  <div class="card-header font-weight-bold text-center">
    <slot name="header"></slot>
  </div>
  <div class="card-body">
    <ul class="list-unstyled mb-0 job-card-list">
      <slot name="body"></slot>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  props: ['additionalClasses']
}
</script>

<style lang="scss" scoped>
  .job-card {
    border-radius: 0;
    border-color: $light;
  }
  .job-card .card-header {
    font-size: 1rem;
    color: $dark;
    border-radius: 0;
    border: 0;
    background-color: $light;
  }
  .job-card.style-success .card-header {
    background-color: #d4edda;
  }
  .job-card.style-danger .card-header {
    background-color: #f8d7da;
  }
  .job-card-list li {
    position: relative;
  }
  .job-card-list li + li {
    margin-top: 6px;
  }
  .job-card-list li.with-icon {
    padding-left: 30px;
  }
  .job-card-list li.with-icon .fa {
    position: absolute;
    top: 4px;
    left: 0;
  }

  @media (min-width: 992px) {
    .columns-3 .job-card-list {
      columns: 3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/job/JobDetailsCard.vue